<template>
  <!-- 图片列表 -->
  <div class="page_padding">
    <div>
      <div class="head">
        <!-- 筛选 -->
        <ul class="screening_box">
          <li>
            <el-input
              placeholder="请输入urlId"
              v-model="searchForm.urlId"
              @change="search"
              clearable
            >
            </el-input>
          </li>
          <li>
            <el-input
              placeholder="请输入批次号"
              v-model="searchForm.batchId"
              @change="search"
              clearable
            >
            </el-input>
          </li>
          <li>
            <el-input
              placeholder="请输入来源"
              v-model="searchForm.source"
              @change="search"
              clearable
            >
            </el-input>
          </li>
          <li>
            <el-input
              placeholder="请输入url"
              v-model="searchForm.url"
              @change="search"
              clearable
            >
            </el-input>
          </li>
          <li>
            <el-select
              v-model="searchForm.status"
              clearable
              placeholder="请选择图片状态"
            >
              <el-option
                v-for="key in Object.keys(status)"
                :key="key"
                :label="status[key].status"
                :value="key"
              >
              </el-option>
            </el-select>
          </li>
        </ul>
        <el-button type="primary" size="mini" plain @click="postExcel"
          >导入</el-button
        >
      </div>
      <!-- 列表 -->
      <div id="table_list">
        <el-table
          ref="table"
          v-load="loading"
          :data="tableData"
          style="width: 100%"
          :height="table_height"
        >
          <el-table-column label="当前状态" width="90">
            <template slot-scope="scope">
              <span :style="'color:' + status[scope.row.status].color">{{
                status[scope.row.status].status
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="图片" width="80">
            <template slot-scope="scope">
              <el-image
                style="width: 50px; height: 50px"
                :src="scope.row.url"
                fit="cover"
                :preview-src-list="[scope.row.url]"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="source" label="来源" width="80">
          </el-table-column>
          <el-table-column prop="text" label="识别结果"> </el-table-column>
          <el-table-column prop="batchId" label="批次号"> </el-table-column>
          <el-table-column prop="createTime" label="时间" width="180">
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页器 -->
      <div class="paging_box">
        <!-- 导出按钮 -->
        <exportBtn url="/ocr/export" :params="searchForm" />
        <span class="total">共{{ total }}条</span>
        <span class="perPage_num">本页{{ tableData.length }}条</span>
        <el-pagination
          layout="prev, pager, next"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @current-change="changePage"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 导入弹窗 -->
    <upLoad
      title="导入图片Excel"
      v-model="dialogVisible"
      :url="$api.upLoadImg"
      @upLoadSuccess="upLoadSuccess"
    />
  </div>
</template>

<script>
import upLoad from "../components/upload.vue";
import exportBtn from "../components/exportBtn.vue";

export default {
  components: { upLoad, exportBtn },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      page: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      table_height: 400,
      // 搜索数据
      searchForm: {
        urlId: "",
        batchId: "",
        source: "",
        url: "",
        status: ""
      },
      status: {
        0: { color: "#F56C6C", status: "处理异常接口" },
        1: { color: "#409EFF", status: "新任务" },
        2: { color: "#909399", status: "队列中" },
        3: { color: "#E6A23C", status: "识别中" },
        4: { color: "#F56C6C", status: "识别错误" },
        5: { color: "#67C23A", status: "识别完成" }
      },
      file: {}
    };
  },
  computed: {},
  watch: {
    "searchForm.status": {
      deep: true,
      handler() {
        this.search();
      }
    }
  },
  mounted() {
    this.getList();
    this.$nextTick(() => {
      this.changeTableHeight("init");
    });

    window.onresize = () => {
      this.changeTableHeight("onresize");
    };
  },
  methods: {
    // 获取列表
    getList() {
      this.loading = true;
      this.$refs.table.bodyWrapper.scrollTop = 0;
      let data = JSON.parse(JSON.stringify(this.searchForm));
      data.pageSize = this.pageSize;
      data.pageIndex = this.page;
      this.$http({
        url: this.$api.img_list,
        data,
        baseUrl: true
      }).then(res => {
        this.loading = false;
        if (res.code == 0) {
          this.total = res.data.total;
          this.tableData = res.data.list;
        }
      });
    },
    // 点击导入Excel
    postExcel() {
      this.dialogVisible = true;
    },
    // 导入完成
    upLoadSuccess() {
      this.searchForm.urlId = "";
      this.searchForm.batchId = "";
      this.searchForm.source = "";
      this.searchForm.url = "";
      this.searchForm.status = "";
      this.search();
    },
    // 搜索
    search() {
      this.page = 1;
      this.getList();
    },
    // 翻页
    changePage(e) {
      this.page = e;
      this.getList();
    },
    // 计算表格高度
    changeTableHeight(type) {
      let height = document.getElementById("table_list").offsetHeight;
      if (type == "onresize" && this.table_height == height) return;
      this.table_height = height;
      if (this.table_height < 550) {
        this.dialog_top = "5vh";
      } else {
        this.dialog_top = "15vh";
      }
    }
  }
};
</script>

<style></style>
<style lang="less" scoped>
.head {
  padding-right: 0px;
}

.screening_box {
  > li {
    display: flex;
    align-items: center;
    white-space: nowrap;
    font-size: 13px;
    margin-right: 10px;
    &:nth-last-child(1) {
      margin-right: 0px;
    }
  }
}
/deep/.screening_box {
  .el-input__inner {
    margin-left: 0;
  }
}
.table_list {
  border-radius: 4px;
  overflow: hidden;
}

.paging_box {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/pages/identify/views/imgIdentify.vue